export enum OtherPaymentPaymentType {
    MEALS = 1,
    LODGING = 2,
    MEALSTAXED = 3,
    LODGINGTAXED = 4,
    SHIFTBONUS = 5,
    AIRFARE = 11,
    RENTAL_CAR = 14,
    MILEAGE = 26,
    HOTEL_REIMBURSEMENT = 27,
    MISCELLANEOUS = 30
}
